import { api } from './api';
import { PaginatedList, PaginatedRequest } from '../types';

export const getSpecialPermissionList = (
  params: PaginatedRequest,
) =>
  api.request<SpecialPermissionListType>({
    method: 'GET',
    url: '/special_permissions/',
    params,
  });

export const createSpecialPermission = (
  data: SpecialPermissionType,
) =>
  api.request<SpecialPermissionType>({
    method: 'POST',
    url: '/special_permissions/',
    data,
  });

export const updateSpecialPermission = (
  data: SpecialPermissionType,
) =>
  api.request<SpecialPermissionType>({
    method: 'PATCH',
    url: `/special_permissions/${data.id}/`,
    data,
  });

/**
 * Soft delete. Rows whose key is read by an automation are refused with a
 * 400 rather than removed -- deactivating one is the reversible way to
 * switch its automation off.
 */
export const deleteSpecialPermission = (id: number) =>
  api.request<SpecialPermissionType>({
    method: 'DELETE',
    url: `/special_permissions/${id}/`,
  });

/**
 * Active employees, system-wide.
 *
 * The shared `/account/users/` list is scoped to the caller's franchises and
 * comes back empty for a Super Admin, so the assignee picker reads this --
 * the same reason Message Setup has its own inspector endpoint.
 */
export const getAssignableUsers = () =>
  api.request<AssignableUser[]>({
    method: 'GET',
    url: '/special_permissions/users/',
  });

type SpecialPermissionListType = PaginatedList<
  SpecialPermissionType
>;

export interface AssignableUser {
  id: number;
  name: string;
  email: string;
}

export interface SpecialPermissionType {
  id?: number;
  /** Stable handle the automation looks up. Never editable. */
  key?: string;
  name?: string;
  permissionType?: string;
  description?: string;
  assignedUser?: number | null;
  assignedUserDisplay?: string;
  isActive?: boolean;
  updatedAt?: string;
  isDeleted?: boolean;
}
